export const SOCIAL_HISTORY = {
  key: 'SOCIAL_HISTORY',
  value: 10,
  group: 1,
  title: 'health-record.social-history.title',
  sub_title: 'Social Habit',
  menu_title: 'health-record.social-history.title',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Social-Habits.svg'),
  icon: 'repeat',
  editor: 'SocialHistoryEditor',
  message_translate: 'health-record.social-history.message',
  model_name: 'social_history',
  resource: 'hr/socialhistory/',
  plain_resource: 'socialhistory',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.social-history.category',
      value: 'record.category',
    },
    {
      text: 'health-record.social-history.frequency',
      value: 'record.frequency.value',
    },
    {
      text: 'health-record.social-history.interval',
      value: 'record.interval.value',
    },
    {
      text: 'health-record.social-history.start-age',
      value: 'record.start_age',
    },
    {
      text: 'health-record.social-history.end-age',
      value: 'record.end_age',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      category: 'category',
      start_age: 'start_age',
      frequency: 'frequency',
      end_age: 'end_age',
      specialist_intervention: 'specialist_intervention',
    },
  },
  show_menu: true,
  background: 'linear-gradient(124.92deg, #8B00DD 5.12%, #BA00E5 100%)',
  color: '#B501E4',
  opaque: '#ECC8F6',
}
